export interface IErrorLogger {
    error(str: string): void;
}

export type TCallback = () => void;

export interface IAwakenListener {
    awaken(callback: TCallback): void;
    unsubscribe(callback: TCallback): void;
}

export class SleepModeDetector implements IAwakenListener {
    private callbacks: TCallback[] = [];
    private timerId: ReturnType<typeof setTimeout> | null = null;

    private tick(): void {
        let from = Date.now();
        this.timerId = setTimeout(() => {
            let to = Date.now();

            if (
                (to - from) / SleepModeDetector.durationInMs >
                SleepModeDetector.deviationAllowed
            ) {
                try {
                    this.callbacks.forEach((callback) => callback());
                } catch (e) {
                    this.logger &&
                        this.logger.error(
                            "One of sleep mode detector listeners has thrown an error. " +
                                (e as Error).message
                        );
                }
            }

            this.tick();
        }, SleepModeDetector.durationInMs);
    }

    constructor(private readonly logger?: IErrorLogger) {}

    awaken(callback: TCallback) {
        this.callbacks.push(callback);
        if (!this.timerId) {
            this.tick();
        }
    }

    unsubscribe(callback: TCallback) {
        this.callbacks = this.callbacks.filter((f) => f !== callback);
        if (this.timerId && !this.callbacks.length) {
            clearTimeout(this.timerId);
        }
        this.timerId = null;
    }

    static durationInMs = 5000;
    static deviationAllowed = 1.2;
}

